var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sortList"},[_c('v-select',{attrs:{"items":_vm.items,"solo":"","dense":true,"color":"#58abe7"},on:{"change":_vm.selection},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }